import { isTestAppHost, isTrainingHost } from "@shared/tenantSlug";

/** Erkennung der Dev-App-Hosts (siehe apiClient.ts / CORS in api/config.py). */
export function isDevAppHostname(hostname: string): boolean {
  return (
    hostname.startsWith("dev.app.") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  );
}

export function isDevAppHost(): boolean {
  if (typeof window === "undefined") return false;
  // Vite-Dev-Server, auch wenn die Seite über eine LAN-IP statt localhost läuft.
  if (import.meta.env.DEV) return true;
  return isDevAppHostname(window.location.hostname);
}

/** Schulungs-Hosts test.app.* auf der Produktions-Codebasis. */
export function isTestAppHostRuntime(): boolean {
  if (typeof window === "undefined") return false;
  return isTestAppHost(window.location.hostname);
}

/** Nur test.app.* (nicht dev.app.*) – z. B. Produktionsdaten laden. */
export function isProductionCloneAppHost(): boolean {
  return isTestAppHostRuntime();
}

/** Dev oder Schulungs-Host – Demodaten laden. */
export function isTrainingAppHost(): boolean {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  return isDevAppHost() || isTrainingHost(hostname);
}

/** Nur Dev-Umgebung – Testdaten löschen, Hard-Delete von Plätzen. */
export function isDevDataDeletionHost(): boolean {
  return isDevAppHost();
}

export type MailboxReadStateMode = "live" | "dev" | "training";

/**
 * Ob das Öffnen einer Mail `isRead` im gemeinsamen Postfach setzen darf.
 * Dev-App und Schulungs-Host lesen dasselbe Postfach wie die Produktion.
 */
export function mailboxReadStateMode(): MailboxReadStateMode {
  if (typeof window === "undefined") return "live";
  if (isTestAppHost(window.location.hostname)) return "training";
  if (import.meta.env.DEV || isDevAppHostname(window.location.hostname)) return "dev";
  return "live";
}

export function mailboxReadStateHint(mode: MailboxReadStateMode): string | null {
  if (mode === "dev") return "Dev-Ansicht: Lesen ändert den Gelesen-Status im Postfach nicht.";
  if (mode === "training") return "Schulung: Lesen ändert den Gelesen-Status im Postfach nicht.";
  return null;
}

/** iPhone/iPad/iPod inkl. iPadOS mit Desktop-UA. */
export function isIosTouchDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}
